export default __webpack_public_path__ + "static/media/error404.3edf53fb.svg";